import {
  clearCollections,
  setCollection,
  setSubCollection,
  clearSelectedCollectionOption,
  clearSubCollections,
} from "@redux/slices/searchFilters";
import { convertSubOptionsToJewelryPayload } from "@scenes/searchResults/Utils";

const getSearchParams = (searchParams: any) => {
  const vdb: { [k: string]: any } = searchParams;

  vdb.featured =
    !!searchParams.featured && searchParams.featured === "true"
      ? "true"
      : "false";

  // parcel
  if (searchParams.parcel) {
    vdb.parcel = searchParams.parcel;
  }

  // shapes
  if (searchParams.shapes && searchParams.shapes.length > 0) {
    vdb.shapes = searchParams.shapes;
  }

  // argyles
  if (searchParams.argyle) {
    vdb.argyle = searchParams.argyle;
  }

  // carat
  if (searchParams.minCarat != null) {
    vdb.size_from = searchParams.minCarat;
  }

  if (searchParams.maxCarat != null) {
    vdb.size_to = searchParams.maxCarat;
  }

  // colors
  if (searchParams.simpleColors && searchParams.simpleColors.length > 0) {
    vdb.color_from = searchParams.simpleColors[0];
    vdb.color_to =
      searchParams.simpleColors[searchParams.simpleColors.length - 1];
  }

  // fancy colors
  if (searchParams.fancyColors1 && searchParams.fancyColors1.length > 0) {
    vdb.fancy_colors = searchParams.fancyColors1;
  }

  // fancy color intensity
  if (searchParams.fancyColors2 && searchParams.fancyColors2.length > 0) {
    vdb.fancy_color_intensity_from = searchParams.fancyColors2[0];
    vdb.fancy_color_intensity_to =
      searchParams.fancyColors2[searchParams.fancyColors2.length - 1];
  }

  // fancy color overtones
  if (
    searchParams.fancyColorsOvertones &&
    searchParams.fancyColorsOvertones.length > 0
  ) {
    vdb.fancy_color_overtones = searchParams.fancyColorsOvertones;
  }

  // clarities
  if (searchParams.clarities && searchParams.clarities.length > 0) {
    vdb.clarity_from = searchParams.clarities[0];
    vdb.clarity_to = searchParams.clarities[searchParams.clarities.length - 1];
  }

  // Cut
  if (searchParams.cutGrades && searchParams.cutGrades.length > 0) {
    vdb.cut_from = searchParams.cutGrades[0];
    vdb.cut_to = searchParams.cutGrades[searchParams.cutGrades.length - 1];
  }

  // polish
  if (searchParams.polishes && searchParams.polishes.length > 0) {
    vdb.polish_from = searchParams.polishes[0];
    vdb.polish_to = searchParams.polishes[searchParams.polishes.length - 1];
  }

  // symmetries
  if (searchParams.symmetries && searchParams.symmetries.length > 0) {
    vdb.symmetry_from = searchParams.symmetries[0];
    vdb.symmetry_to =
      searchParams.symmetries[searchParams.symmetries.length - 1];
  }

  // threeX
  if (searchParams.three_x) {
    vdb.three_x = searchParams.three_x;
    if (searchParams.symmetries && searchParams.symmetries.length > 0) {
      vdb.cps = [
        searchParams.symmetries[searchParams.symmetries.length - 1],
        searchParams.symmetries[0],
      ];
    }
  }

  // threeVgPlus
  if (searchParams.three_vg_plus) {
    vdb.three_vg_plus = searchParams.three_vg_plus;
    if (searchParams.symmetries && searchParams.symmetries.length > 0) {
      vdb.cps = [
        searchParams.symmetries[searchParams.symmetries.length - 1],
        searchParams.symmetries[0],
      ];
    }
  }

  // eightX
  if (searchParams.eight_x) {
    vdb.eight_x = searchParams.eight_x;
    if (searchParams.symmetries && searchParams.symmetries.length > 0) {
      vdb.cps = [
        searchParams.symmetries[searchParams.symmetries.length - 1],
        searchParams.symmetries[0],
      ];
    }
  }

  // hearts and arrows
  if (searchParams.hearts_and_arrows) {
    vdb.hearts_and_arrows = searchParams.hearts_and_arrows;
  }

  // fluorescences
  if (searchParams.fluorescences && searchParams.fluorescences.length > 0) {
    vdb.fluorescence_intensities = searchParams.fluorescences;
  }

  // fluorescences
  if (searchParams.labs && searchParams.labs.length > 0) {
    vdb.labs = searchParams.labs;
  }

  // locations
  if (
    searchParams.vendor_locations &&
    searchParams.vendor_locations.length > 0
  ) {
    vdb.vendor_locations = searchParams.vendor_locations;
  }

  // supplier
  if (searchParams.companyNames && searchParams.companyNames.length > 0) {
    vdb.company_names = searchParams.companyNames;
  }

  // depth
  if (searchParams.minDepth != null) {
    vdb.depth_percent_from = searchParams.minDepth;
  }

  if (searchParams.maxDepth != null) {
    vdb.depth_percent_to = searchParams.maxDepth;
  }

  // table
  if (searchParams.minTable != null) {
    vdb.table_percent_from = searchParams.minTable;
  }

  if (searchParams.maxTable != null) {
    vdb.table_percent_to = searchParams.maxTable;
  }

  // price per carat
  if (searchParams.minPricePerCt != null) {
    vdb.price_per_carat_from = searchParams.minPricePerCt;
  }

  if (searchParams.maxPricePerCt != null) {
    vdb.price_per_carat_to = searchParams.maxPricePerCt;
  }

  if (searchParams.total_or_price_per_carat) {
    vdb.total_or_price_per_carat = searchParams.total_or_price_per_carat;
  }

  // total price
  if (searchParams.minBudget != null) {
    vdb.price_total_from = searchParams.minBudget.toString();
  }

  if (searchParams.maxBudget != null) {
    vdb.price_total_to = searchParams.maxBudget.toString();
  }

  // enhancements
  if (searchParams.enhancements && searchParams.enhancements.length > 0) {
    if (searchParams.enhancements.indexOf("Color Enhanced") !== -1) {
      searchParams.enhancements[
        searchParams.enhancements.indexOf("Color Enhanced")
      ] = "HPHT";
    }
    vdb.enhancements = searchParams.enhancements;
  }

  // meas_length
  if (searchParams.meas_length_from != null) {
    vdb.meas_length_from = searchParams.meas_length_from;
  }

  if (searchParams.meas_length_to != null) {
    vdb.meas_length_to = searchParams.meas_length_to;
  }

  // meas_width
  if (searchParams.meas_width_from != null) {
    vdb.meas_width_from = searchParams.meas_width_from;
  }

  if (searchParams.meas_width_to != null) {
    vdb.meas_width_to = searchParams.meas_width_to;
  }

  // meas_depth
  if (searchParams.meas_depth_from != null) {
    vdb.meas_depth_from = searchParams.meas_depth_from;
  }

  if (searchParams.meas_depth_to != null) {
    vdb.meas_depth_to = searchParams.meas_depth_to;
  }

  // ratio
  if (searchParams.meas_ratio_from != null) {
    vdb.meas_ratio_from = searchParams.meas_ratio_from;
  }

  if (searchParams.meas_ratio_to != null) {
    vdb.meas_ratio_to = searchParams.meas_ratio_to;
  }

  if (searchParams.growth_type != null) {
    vdb.growth_type = searchParams.growth_type;
  }

  if (
    searchParams.certifications != null &&
    searchParams.certifications.length > 0
  ) {
    vdb.certifications = searchParams.certifications;
  }

  if (searchParams.eye_clean != null) {
    vdb.eye_clean = searchParams.eye_clean;
  }

  if (searchParams.no_bgm != null) {
    vdb.no_bgm = searchParams.no_bgm;
  }

  if (searchParams.pair != null) {
    vdb.pair = searchParams.pair;
  }

  if (searchParams.additional_attributes) {
    vdb.additional_attributes = searchParams.additional_attributes;
  }

  if (searchParams.with_images) {
    vdb.with_images = searchParams.with_images;
  }

  if (searchParams.with_available_items) {
    vdb.with_available_items = searchParams.with_available_items;
  }

  if (searchParams.discount_percent_from != null) {
    vdb.discount_percent_from = searchParams.discount_percent_from;
  }

  if (searchParams.discount_percent_to != null) {
    vdb.discount_percent_to = searchParams.discount_percent_to;
  }

  if (
    searchParams.stone_types != null &&
    Array.isArray(searchParams.stone_types) &&
    searchParams.stone_types.length > 0
  ) {
    vdb.stone_types = searchParams.stone_types;
  }

  // cert_num
  if (searchParams.cert_num) vdb.cert_num = searchParams.cert_num;

  return vdb;
};

const getSearchParamsJewelry = (
  searchOptions: any,
  dispatch?: any,
  fromSearchResults?: boolean
) => {
  const searchParams: { [k: string]: any } = searchOptions;
  if (searchParams.sub_collection && searchParams.sub_collection.length > 0) {
    if (dispatch) {
      dispatch(clearSubCollections());
      dispatch(clearCollections());
      dispatch(clearSelectedCollectionOption());
      dispatch(
        setCollection(
          searchParams.collection_names?.length
            ? searchParams.collection_names
            : searchParams.sub_collection
        )
      );
      dispatch(setSubCollection(searchParams.sub_collection));
    }
    if (
      !searchParams.collection_names ||
      searchParams.collection_names.length === 0
    ) {
      searchParams.collection_names = [
        ...new Set([...searchParams.sub_collection]),
      ];
    }
  } else if (
    searchParams.collection_names &&
    searchParams.collection_names.length > 0
  ) {
    if (dispatch) {
      dispatch(clearSelectedCollectionOption());
      dispatch(clearSubCollections());
      dispatch(clearCollections());
      dispatch(setCollection(searchParams.collection_names));
    }
  }

  // carat
  if (searchOptions.minCarat != null && searchOptions.minCarat !== 0) {
    searchParams.size_from = searchOptions.minCarat;
  }

  if (searchOptions.maxCarat != null && searchOptions.maxCarat !== 1000) {
    searchParams.size_to = searchOptions.maxCarat;
  }

  if (searchOptions.is_center_size_selected) {
    searchParams.is_center_size_selected = "true";
  }

  // locations
  if (
    searchOptions.vendorLocations &&
    searchOptions.vendorLocations.length > 0
  ) {
    searchParams.vendor_locations = searchOptions.vendorLocations;
  }

  // supplier
  if (searchOptions.companyNames && searchOptions.companyNames.length > 0) {
    searchParams.company_names = searchOptions.companyNames;
    searchParams.location_for = "supplier";
  }

  // total price
  if (searchOptions.minBudget != null && searchOptions.minBudget !== 0) {
    searchParams.price_total_from = searchOptions.minBudget;
  }

  if (
    searchOptions.maxBudget != null &&
    searchOptions.maxBudget !== 10000000000
  ) {
    searchParams.price_total_to = searchOptions.maxBudget;
  }

  // brands
  if (searchOptions.brands && searchOptions.brands.length > 0) {
    searchParams.brands = searchOptions.brands;
  }

  // jewelry styles
  if (
    searchOptions.jewelry_styles &&
    Object.keys(searchOptions.jewelry_styles).length > 0
  ) {
    searchParams.jewelry_styles = searchOptions.jewelry_styles;
    if (searchParams.jewelry_styles.jewelry_types) {
      delete searchParams.jewelry_styles.jewelry_types;
    }
  }

  // metals

  if (searchOptions.metals && searchOptions.metals.length > 0) {
    if (
      searchParams.collection_names &&
      searchParams.collection_names.length > 0 &&
      fromSearchResults
    ) {
      const search_params_Metals = convertSubOptionsToJewelryPayload(
        searchParams,
        "metals"
      );
      searchParams.metals = search_params_Metals.metals;
    } else {
      searchParams.metals = searchOptions.metals;
    }
  }

  // stone_type
  if (searchOptions.stone_type && searchOptions.stone_type.length > 0) {
    searchParams.stone_type = searchOptions.stone_type;
  }

  // cert_num
  if (searchOptions.cert_num) searchParams.cert_num = searchOptions.cert_num;

  // Navigation links store the last request's additional_filters alongside the
  // selected fields. Keep any value that exists only there, then drop the
  // nested copy so a later jewelry-type change cannot reuse stale keys.
  if (
    searchParams.additional_filters &&
    typeof searchParams.additional_filters === "object" &&
    !Array.isArray(searchParams.additional_filters)
  ) {
    Object.keys(searchParams.additional_filters).forEach((key) => {
      const value = searchParams.additional_filters[key];
      if (
        value &&
        (searchParams[key] === undefined || searchParams[key] === null)
      ) {
        searchParams[key] = value;
      }
    });
    delete searchParams.additional_filters;
  }

  Object.keys(searchOptions).forEach((key) => {
    if (!(key in searchParams)) {
      searchParams[key] = searchOptions[key];
    }
  });

  if (searchOptions.stock_item_ids) {
    searchParams.stock_item_ids = searchOptions.stock_item_ids;
  }

  return searchParams;
};

const getSearchParamsGemstone = (searchOptions: any) => {
  const searchParams = searchOptions;

  // carat
  if (searchOptions.minCarat != null && searchOptions.minCarat !== 0) {
    searchParams.size_from = searchOptions.minCarat;
  }
  if (searchOptions.maxCarat != null && searchOptions.maxCarat !== 1000) {
    searchParams.size_to = searchOptions.maxCarat;
  }

  // locations
  if (
    searchOptions.vendorLocations &&
    searchOptions.vendorLocations.length > 0
  ) {
    searchParams.vendor_locations = searchOptions.vendorLocations;
  }

  // supplier
  if (searchOptions.companyNames && searchOptions.companyNames.length > 0) {
    searchParams.company_names = searchOptions.companyNames;
    searchParams.location_for = "supplier";
  }

  // total price
  if (searchOptions.minBudget != null && searchOptions.minBudget !== 0) {
    searchParams.price_total_from = searchOptions.minBudget;
  }
  if (
    searchOptions.maxBudget != null &&
    searchOptions.maxBudget !== 10000000000
  ) {
    searchParams.price_total_to = searchOptions.maxBudget;
  }

  // brands
  if (searchOptions.brands && searchOptions.brands.length > 0) {
    searchParams.brands = searchOptions.brands;
  }

  if (searchOptions.additional_attributes) {
    searchParams.additional_attributes = searchOptions.additional_attributes;
  }

  if (searchOptions.with_images) {
    searchParams.with_images = searchOptions.with_images;
  }

  if (searchOptions.with_available_items) {
    searchParams.with_available_items = searchOptions.with_available_items;
  }

  if (
    searchOptions.stone_types != null &&
    Array.isArray(searchOptions.stone_types) &&
    searchOptions.stone_types.length > 0
  ) {
    searchParams.stone_types = searchOptions.stone_types;
  }

  // cert_num
  if (searchOptions.cert_num) searchParams.cert_num = searchOptions.cert_num;

  return searchParams;
};

export { getSearchParams, getSearchParamsJewelry, getSearchParamsGemstone };
